import { useMemo } from 'react';
import { createMarker } from '@src/utils';

export const useCopiedLocationItems = ({
  selectedSegment,
  index,
}: {
  index: number;
  selectedSegment: any;
}) => {
  const locations = useMemo(() => {
    const copiedSegmentItemLocations = structuredClone([
      selectedSegment?.pickupLocations,
      selectedSegment?.dropOffLocation,
    ]);

    if (copiedSegmentItemLocations[0]) {
      copiedSegmentItemLocations[0].marker = createMarker(
        copiedSegmentItemLocations[0],
        `${index + 1}`,
        '#FC8441FF',
        'Start'
      );
    }

    if (copiedSegmentItemLocations[1]) {
      copiedSegmentItemLocations[1].marker = createMarker(
        copiedSegmentItemLocations[1],
        `${index + 2}`,
        '#FC8441FF',
        'End'
      );
    }

    return copiedSegmentItemLocations;
  }, [selectedSegment, index]);

  return { locations };
};
